module.exports = __webpack_public_path__ + "static/img/flower.8375026.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/flower.png
// module id = wSRb
// module chunks = 0